<div class="notifications-hub">
    <h2>{{'centralNotificaciones.titulo' | translate}}</h2>
    <div class="table-wrapper">
        <div class="table-container">
            <table>
                <thead>
                    <tr>
                        <th class="icon" *ngIf="this.role !== 'Administrador'"></th>
                        <th *ngIf="this.role === 'Administrador'" class="string first-column">
                            {{'centralNotificaciones.table.rol' | translate}}
                        </th>
                        <th *ngIf="this.role === 'Administrador'" class="string">
                            {{'centralNotificaciones.table.entidad' | translate}}
                        </th>
                        <th *ngIf="this.role === 'Administrador'" class="string">
                            {{'centralNotificaciones.table.etiquetador' | translate}}
                        </th>
                        <th *ngIf="this.role === 'Administrador'" class="string">
                            {{'global.pais' | translate}}
                        </th>
                        <th *ngIf="this.role === 'Administrador'" class="string">
                            {{'centralNotificaciones.table.denominacion' | translate}}
                        </th>
                        <th class="string">
                            {{'centralNotificaciones.table.titulo' | translate}}
                        </th>
                        <th *ngIf="this.role === 'Administrador'" class="date">
                            {{'global.fecha.insercionShort' | translate}}
                        </th>
                        <th *ngIf="this.role === 'Administrador'" class="date">
                            {{'global.fecha.actualizacionShort' | translate}}
                        </th>
                        <th class="date">{{'centralNotificaciones.table.fechaEnvio' | translate}}</th>
                        <th class="action" *ngIf="this.role === 'Administrador'">
                            <i class="fas fa-plus" (click)="create()" title="{{'centralNotificaciones.tituloNew' | translate}}"></i>
                        </th>
                    </tr>
                </thead>
                <ng-container *ngIf="notificaciones && notificaciones.length > 0">
                    <tbody *ngFor="let notificacion of notificaciones; let i = index">
                        <tr (click)="showDetails(notificacion.id, notificacion.pendienteLecturaCurrentUser)" style="cursor: pointer;">
                            <td *ngIf="this.role !== 'Administrador'" class="icon" [ngClass]="!notificacion.pendienteLecturaCurrentUser ? 'notification-read' : 'notification'" [attr.title]="!notificacion.pendienteLecturaCurrentUser ? ('centralNotificaciones.leida' | translate) : ('centralNotificaciones.nueva' | translate)"></td>
                            <td *ngIf="this.role === 'Administrador'" class="string first-column">
                                <ng-container *ngIf="notificacion.rolDestinatarioId === 1">
                                    {{'centralNotificaciones.table.todos' | translate}}
                                </ng-container>
                                <ng-container *ngIf="notificacion.rolDestinatarioId === 2">
                                    {{'centralNotificaciones.table.entidad' | translate}}
                                </ng-container>
                                <ng-container *ngIf="notificacion.rolDestinatarioId === 3">
                                    {{'centralNotificaciones.table.etiquetador' | translate}}
                                </ng-container>
                            </td>
                            <td *ngIf="this.role === 'Administrador'" class="string">
                                <ng-container *ngIf="!notificacion.todosEntidadControl && notificacion.respEntidades">
                                    <ng-container *ngFor="let entidad of notificacion.respEntidades; let p = index">
                                        <span>{{entidad.des}}</span><span *ngIf="p !== (notificacion.respEntidades.length - 1)">, </span>
                                    </ng-container>
                                </ng-container>
                                <ng-container *ngIf="notificacion.todosEntidadControl">
                                    {{'centralNotificaciones.table.todas' | translate}}
                                </ng-container>
                            </td>
                            <td *ngIf="this.role === 'Administrador'" class="string">
                                <ng-container *ngIf="!notificacion.todosEtiquetador && notificacion.respEtiquetadores">
                                    <ng-container *ngFor="let etiquetador of notificacion.respEtiquetadores; let p = index">
                                        <span>{{etiquetador.des}}</span><span *ngIf="p !== (notificacion.respEtiquetadores.length - 1)">, </span>
                                    </ng-container>
                                </ng-container>
                                <ng-container *ngIf="notificacion.todosEtiquetador">
                                    {{'centralNotificaciones.table.todos' | translate}}
                                </ng-container>
                            </td>
                            <td *ngIf="this.role === 'Administrador'" class="string">
                                <ng-container *ngIf="!notificacion.allPaises">
                                    <ng-container *ngFor="let pais of notificacion.respPaises; let p = index">
                                        <span>{{pais.des}}</span><span *ngIf="p !== (notificacion.respPaises.length - 1)">, </span>
                                    </ng-container>
                                </ng-container>
                                <ng-container *ngIf="notificacion.allPaises">
                                    {{'centralNotificaciones.table.todos' | translate}}
                                </ng-container>
                            </td>
                            <td *ngIf="this.role === 'Administrador'" class="string">
                                <ng-container *ngIf="!notificacion.allDenominaciones">
                                    <ng-container *ngFor="let denominacion of notificacion.respDenominaciones; let p = index">
                                        <span>{{denominacion.des}}</span><span *ngIf="p !== (notificacion.respDenominaciones.length - 1)">, </span>
                                    </ng-container>
                                </ng-container>
                                <ng-container *ngIf="notificacion.allDenominaciones">
                                    {{'centralNotificaciones.table.todas' | translate}}
                                </ng-container>
                            </td>
                            <td class="string">{{notificacion.titulo}}</td>
                            <td *ngIf="this.role === 'Administrador'" class="date">
                                {{notificacion.fechaIns | date: 'shortDate' : undefined : defaultLanguage}}
                            </td>
                            <td *ngIf="this.role === 'Administrador'" class="date">
                                {{notificacion.fechaUpd | date: 'shortDate' : undefined : defaultLanguage}}
                            </td>
                            <td class="date">{{notificacion.fechaEnvio | date: 'shortDate' : undefined : defaultLanguage}}</td>
                            <td class="multi-actions" *ngIf="this.role === 'Administrador'">
                                <i class="fas fa-pencil-alt" app-click-stop-propagation (click)="editNotification(notificacion)" title="{{'titles.editar' | translate}}"></i>
                                <i class="far fa-trash-alt" app-click-stop-propagation (click)="showDeleteModal(notificacion.id)" title="{{'titles.eliminar' | translate}}"></i>
                            </td>
                        </tr>
                        <tr *ngIf="dropdownInfo === notificacion.id">
                            <td [attr.colspan]="this.role === 'Administrador' ? 11 : 3" class="string-long">
                                <div class="detail">
                                    <div class="title">{{'global.masInformacion' | translate}}</div>
                                    <div class="block">
                                        <label>{{'centralNotificaciones.notificacion' | translate}}</label>
                                        <p style="white-space: normal;">{{detalle}}</p>
                                        <a *ngIf="detalleLink" target="_blank" [href]="detalleLink">{{detalleLink}}</a>
                                    </div>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </ng-container>
                <tfoot *ngIf="!notificaciones || (notificaciones && notificaciones.length < 1)">
                    <tr>
                        <td [attr.colspan]="this.role === 'Administrador' ? 11 : 4">
                            {{'global.noContent' | translate}}
                        </td>
                    </tr>
                </tfoot>
            </table>
        </div>
    </div>
    <app-paginator *ngIf="notificaciones && notificaciones.length > 0" [itemsPerPage]="itemsPerPage" [currentPage]="currentPage + 1"
        [totalItems]="totalItems" [visiblePages]="visiblePages" (pageChange)="pageChange($event)"
        (itemsPerPageChange)="itemsPerPageChange($event)">
    </app-paginator>
    <app-toast *ngIf="(showError) && mensajes" [messages]="mensajes" (closed)="showError=$event"></app-toast>
</div>
<div class="modal" *ngIf="deleteModal">
    <div class="modal-content">
        <header>
            <h4>{{'global.eliminar.descripcion' | translate}}</h4>
        </header>
        <content>
            <p>{{'global.eliminar.confirmacion' | translate}}</p>
        </content>
        <footer>
            <button class="secondary" (click)="deleteModal=false">{{'global.cancelar' | translate}}</button>
            <button (click)="deleteNotification()">{{'global.confirmar' | translate}}</button>
        </footer>
    </div>
</div>
<div class="modal" *ngIf="newEditModal">
    <div class="modal-content">
        <header>
            <h4>{{notificationId ? ('centralNotificaciones.tituloEdit' | translate) : ('centralNotificaciones.tituloNew' | translate)}}</h4>
        </header>
        <app-not-new-edit [notificationId]="notificationId" (refresh)="refresh($event)" (mensaje)="pushMessage($event)">
        </app-not-new-edit>
    </div>
</div>